import { NgModule } from '@angular/core';
import {
  LclPaymentItemsComponent,
  PaymentBreakdownComponent,
  PaymentMethodsCardComponent,
  PaymentMethodsItemComponent,
} from './components';
import { TranslateModule } from '@ngx-translate/core';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { MutualModule } from '@shared/mutual/mutual.module';
import { CommonModule } from '@angular/common';
import { CustomTooltipModule } from '@shared/tooltip/custom-tooltip.module';
import { CardsModule } from '@shared/cards/cards.module';
import { PaymentButtonExternalModule } from '@shared/payment-button-external/payment-button-external.module';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { PaymentBankAccountDetailsCardComponent } from './components/payment-bank-account-details-card/payment-bank-account-details-card.component';

@NgModule({
  declarations: [
    PaymentBankAccountDetailsCardComponent,
    PaymentMethodsCardComponent,
    PaymentBreakdownComponent,
    LclPaymentItemsComponent,
    PaymentMethodsItemComponent,
  ],
  imports: [
    CommonModule,
    MutualModule,
    TranslateModule,
    PipesSharedModule,
    CustomTooltipModule,
    CardsModule,
    PaymentButtonExternalModule,
    AccordionModule.forRoot(),
  ],
  exports: [
    PaymentBankAccountDetailsCardComponent,
    PaymentMethodsCardComponent,
    PaymentBreakdownComponent,
    LclPaymentItemsComponent,
    PaymentMethodsItemComponent,
  ],
})
export class PaymentSharedModule {}
